




import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    name: 'AppLinkedinFollowPlugin',
})
export default class AppLinkedinFollowPlugin extends Vue {
    @Prop({required: true}) protected companyId!: string;
    @Prop({default: 'right'}) protected counter!: string;

    protected created() {
        this.createLinkedinCounter();
    }

    private createLinkedinCounter() {
        // This file is used to initialize the new Follow Company Widget for XDoor
        // @ts-ignore
        const IN = window.IN;
        const Tag = IN.SDK.Tag;
        const EmbeddedWindow = IN.SDK.EmbeddedWindow;
        const Client = IN.SDK.Client;

        // @ts-ignore
        function FollowCompany(node, core) {
            const tag = new Tag(node, core);
            const tagCounter = tag.attributes.counter;
            const tagId = tag.attributes.id;

            const extensionUrlPrefix = IN.options.get('urls.www.linkedin.com') + '/pages-extensions/FollowCompany';
            const extensionUrl = IN.SDK.addParams(extensionUrlPrefix, {
                id: tagId,
                counter: tagCounter,
            });
            const extensionFrame = new EmbeddedWindow(extensionUrl);
            const client = new Client(extensionFrame);

            tag.insert(extensionFrame.self);
            return tag;
        }

        IN.tags.add('FollowCompany', FollowCompany);
    }
}

